import React from 'react';
import { BookOpen, RefreshCw, ListChecks, ShoppingCart, Pill, LineChart } from 'lucide-react';
export function ProductSection() {
  const features = [{
    icon: <BookOpen className="w-6 h-6" data-id="element-133" />,
    title: 'Manual Maestro',
    desc: 'El paso a paso para entender tu cuerpo.'
  }, {
    icon: <RefreshCw className="w-6 h-6" data-id="element-134" />,
    title: 'Fase Reset',
    desc: 'Protocolo de 14 días de desinflamación.'
  }, {
    icon: <ListChecks className="w-6 h-6" data-id="element-135" />,
    title: 'Método 3-2-1',
    desc: 'Rutina nocturna para un sueño profundo.'
  }, {
    icon: <ShoppingCart className="w-6 h-6" data-id="element-136" />,
    title: 'Lista Súper Arg',
    desc: 'Qué comprar en el súper (adaptado a Argentina).'
  }, {
    icon: <Pill className="w-6 h-6" data-id="element-137" />,
    title: 'Guía Suplementos',
    desc: 'Magnesio, Ashwagandha y más. Qué sirve y qué no.'
  }, {
    icon: <LineChart className="w-6 h-6" data-id="element-138" />,
    title: 'Tracker Cortisol',
    desc: 'Plantilla para medir tu progreso diario.'
  }];
  return <section className="px-4 py-10 bg-sage/10 rounded-t-[3rem] mt-4" data-id="element-139">
      <div className="max-w-md mx-auto" data-id="element-140">
        <div className="text-center mb-8" data-id="element-141">
          <h2 className="text-2xl font-bold text-darkslate mb-2" data-id="element-142">
            Qué te llevás hoy
          </h2>
          <p className="text-gray-600 text-sm" data-id="element-143">
            Todo lo que necesitás para resetear tu metabolismo, sin vueltas.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3" data-id="element-144">
          {features.map((feat, idx) => <div key={idx} className="bg-white p-4 rounded-2xl shadow-sm border border-sage/20 flex flex-col items-center text-center" data-id="element-145">
              <div className="text-sage-dark mb-3 bg-offwhite p-3 rounded-full" data-id="element-146">
                {feat.icon}
              </div>
              <h3 className="font-bold text-sm text-darkslate mb-1" data-id="element-147">
                {feat.title}
              </h3>
              <p className="text-xs text-gray-500 leading-tight" data-id="element-148">{feat.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}